module.exports = __webpack_public_path__ + "static/media/Spheal_gaussian2.dcae16dd.png";